import React from 'react';

const WhyAIDay = () => {
  const pillars = [
    {
      title: 'Real-world Learning',
      description: 'Workshops, demos, tools, applied use-cases',
      icon: (
        <img src="/images/icons/check-icon.svg" alt="Check" className="w-12 h-12" />
      )
    },
    {
      title: 'Build & Showcase',
      description: 'Student & community AI projects',
      icon: (
        <svg className="w-12 h-12 text-crimson" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      )
    },
    {
      title: 'Community & Industry Bridge',
      description: 'Talks, networking, collaboration opportunities',
      icon: (
        <img src="/images/icons/speed-icon.svg" alt="Speed" className="w-12 h-12" />
      )
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-outfit font-800 text-black mb-4 text-center">
          Why We Run <span className="text-crimson">AI Day</span>
        </h2>
        
        <div className="w-24 h-1 bg-crimson mx-auto mb-16"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar, index) => (
            <div 
              key={index}
              className={index === 3 ? "bg-gray-50 p-8 rounded-lg border border-gray-200 hover:border-crimson transition-all duration-300 shadow-sm" : "bg-gray-50 border-2 border-gray-200 p-8 rounded-lg hover:border-crimson transition-all duration-300 transform hover:-translate-y-2 shadow-sm"}
            >
              <div className="mb-4">
                {pillar.icon}
              </div>
              <h3 className={index === 3 ? "text-xl font-outfit font-800 text-black mb-3" : "text-2xl font-outfit font-800 text-black mb-4 relative inline-block"}>
                {pillar.title}
                {index !== 3 && <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-crimson transition-all duration-300 group-hover:w-full"></span>}
              </h3>
              <p className={index === 3 ? "text-gray-600 font-outfit font-600" : "text-gray-600 font-outfit font-600 text-lg"}>
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyAIDay;
